import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LessonList.css';

const LessonList = ({ lessons, onEdit, onDelete, onAssign, assignments = {} }) => {
  const navigate = useNavigate();
  const [expandedLesson, setExpandedLesson] = useState(null);

  const formatVisibilityLabel = (visibleFrom) => {
    if (!visibleFrom) return null;
    const parsed = new Date(visibleFrom);
    if (Number.isNaN(parsed.getTime())) return null;
    return `Synlig fra ${parsed.toLocaleString('no-NO')}`;
  };

  const toggleQuiz = (lessonId) => {
    setExpandedLesson(expandedLesson === lessonId ? null : lessonId);
  };

  return (
    <div className="lessons-grid">
      {lessons.map(lesson => {
        const lessonId = lesson._id || lesson.id;
        return (
        <div key={lessonId} className="lesson-item">
          <div className="lesson-content">
            <h3>{lesson.title}</h3>
            <p className="lesson-details">
              <span>Spørsmål: {lesson.questionCount}</span>
              <span>Typer: {Array.isArray(lesson.quizTypes) ? lesson.quizTypes.join(', ') : Object.keys(lesson.quizTypes || {}).filter(k => lesson.quizTypes[k]).join(', ')}</span>
            </p>
            <p className="lesson-text">{lesson.content}</p>
            <div className="lesson-url">
              <a 
                href={`/quiz/lessons/${lessonId}`}
                target="_blank" 
                rel="noopener noreferrer"
              >
                Ta quiz
              </a>
            </div>
            <button 
              className="view-quiz-btn"
              onClick={() => toggleQuiz(lessonId)}
            >
              {expandedLesson === lessonId ? 'Skjul quiz' : 'Vis quiz'}
            </button>
            {expandedLesson === lessonId && lesson.quiz && (
              <div className="quiz-section">
                {lesson.quiz.map((question, index) => (
                  <div key={index} className="quiz-question">
                    <h4>Spørsmål {index + 1}</h4>
                    <p><strong>Type:</strong> {question.type}</p>
                    <p><strong>Spørsmål:</strong> {question.question}</p>
                    {question.options && (
                      <div className="options">
                        <strong>Alternativer:</strong>
                        <ul>
                          {question.options.map((option, i) => (
                            <li key={i}>{option}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    <p><strong>Riktig svar:</strong> {question.correctAnswer}</p>
                    <p><strong>Forklaring:</strong> {question.explanation}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
          {assignments[lessonId]?.length > 0 && (
            <div className="assignment-info">
              <strong>Tildelt til:</strong>
              <div className="assignment-details">
                {assignments[lessonId].map((assignment, idx) => {
                  const visibilityLabel = formatVisibilityLabel(assignment.visibleFrom);
                  return (
                    <div key={idx} className="assignment-item">
                      {assignment.classIds?.length > 0 && (
                        <span className="assignment-classes">
                          Klasser: {assignment.classIds.map(c => c.name).join(', ')}
                        </span>
                      )}
                      {assignment.studentIds?.length > 0 && (
                        <span className="assignment-students">
                          Elever: {assignment.studentIds.map(s => s.name).join(', ')}
                        </span>
                      )}
                      {visibilityLabel && (
                        <span className="assignment-visibility">
                          {visibilityLabel}
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <div className="lesson-actions">
            {onAssign && (
              <button 
                className="assign-btn"
                onClick={() => onAssign(lessonId)}
              >
                Tildel
              </button>
            )}
            <button 
              className="view-results-btn"
              onClick={() => navigate(`/lessons/${lessonId}/results`)}
            >
              Vis resultater
            </button>
            <button 
              className="edit-btn"
              onClick={() => onEdit(lesson)}
            >
              Rediger
            </button>
            <button 
              className="delete-btn"
              onClick={() => onDelete(lessonId)}
            >
              Slett
            </button>
          </div>
        </div>
        );
      })}
    </div>
  );
};

export default LessonList; 